module.exports = __webpack_public_path__ + "static/media/splnproc1703.e0c8b01b.docm";